import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export abstract class FileUploadService {
	abstract upload(
		type: string,
		namespace: string,
		file: File,
		generateUniqueFilename?: boolean,
	): Observable<HttpEvent<{ progress: number }>>;
}
